import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { createContainer } from 'unstated-next'
import useEventDetailEventTracker from '@/containers/event-tracker/event-detail.event-tracker'
import { useCustomRouter, usePetType } from '@/containers/hooks'
import { useEventByAdSlugLazyQuery } from '@/graphql/generated/hooks'
import { AdType } from '@/graphql/generated/schemas'
import { doSetAdSlugProperties } from '@/stores/reduxData'
import { doSetHeaderTitle } from '@/stores/reduxUI'
import { WelcomeDealSlugKeyType } from '@/types/events-welcome-deal.type'
import { Bridge } from '@/utils/bridge/bridge'
import { getWelcomeDealEventSlug } from '@/utils/event-detail.util'
import appBridgeProvider, { isInAppFlag } from '@/utils/utilBridge'

export type EventContainerProps = {
  ad: AdType
}

/**
 * 이벤트 컨테이너
 * @param initialState - 필수 입력 필요
 */
const eventContainer = (initialState?: EventContainerProps) => {
  const {
    query: { adSlug: eventAdSlug, pagePetType },
  } = useCustomRouter()
  const { trackViewEventsaleDetail } = useEventDetailEventTracker()

  const adSlug =
    getWelcomeDealEventSlug({
      slug: eventAdSlug as string,
      pagePetType: pagePetType as WelcomeDealSlugKeyType,
    }) || eventAdSlug

  const [legacyRefetchEvent, { data }] = useEventByAdSlugLazyQuery({
    fetchPolicy: 'network-only',
    variables: {
      slug: adSlug?.toString() || '',
      filter: {
        orderBy: 'isRealSoldOut,displayOrder',
        isShown: true,
        isRange: true,
        isProductRange: true,
      },
    },
  })
  const ad = data?.adBySlug || initialState!.ad

  const dispatch = useDispatch()

  const { getPetType } = usePetType()
  const petType = getPetType()

  const eventTracking = (ad: AdType) => {
    const properties = trackViewEventsaleDetail(ad)
    dispatch(doSetAdSlugProperties(properties))
  }

  useEffect(() => {
    if (!ad) {
      return
    }
    dispatch(doSetHeaderTitle(ad.name))
  }, [ad])

  useEffect(() => {
    if (isInAppFlag) {
      appBridgeProvider((bridge: Bridge) => bridge.setting({ petTypeMall: petType.toLocaleLowerCase() }))
    }
  }, [petType])

  useEffect(() => {
    legacyRefetchEvent()
    if (initialState?.ad) {
      eventTracking(initialState.ad)
    }
  }, [initialState?.ad])

  return {
    ad,
  }
}

export const EventContainer = createContainer(eventContainer)
